/* eslint-disable */
import React, { useState } from 'react';
import { useSponsors } from '../context/SponsorsContext';
import { 
  RiAddLine, 
  RiEditLine, 
  RiDeleteBack2Fill, 
  RiMedalLine,
  RiAwardLine,
  RiStarLine,
  RiCloseLine,
  RiImageLine 
} from 'react-icons/ri';
import toast from 'react-hot-toast';

const ManageSponsors = () => {
  const { sponsors, addSponsor, updateSponsor, deleteSponsor, loading, error } = useSponsors();
  
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    category: 'platinum',
    description: '',
    website: '',
    image: null,
    imageUrl: '',
    removeImage: false
  });

  const categories = [
    { id: 'platinum', name: 'Platinum', icon: <RiMedalLine />, color: '#e5e4e2' },
    { id: 'gold', name: 'Gold', icon: <RiAwardLine />, color: '#ffd700' },
    { id: 'silver', name: 'Silver', icon: <RiStarLine />, color: '#c0c0c0' }
  ];

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/assets/img/placeholder.png';
    if (imageUrl.startsWith('/uploads')) {
      const apiUrl = 'https://farmo.zuddo.biz/api';
      const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
      return `${backendOrigin}${imageUrl}`;
    }
    return imageUrl;
  };

  const openAddModal = () => {
    console.log('Opening add modal');
    setEditingId(null);
    setFormData({
      name: '',
      category: 'platinum',
      description: '',
      website: '',
      image: null,
      imageUrl: '',
      removeImage: false
    });
    setShowModal(true);
  };

  const openEditModal = (sponsor) => {
    setEditingId(sponsor.id);
    setFormData({
      name: sponsor.name || '',
      category: sponsor.category || 'platinum',
      description: sponsor.description || '',
      website: sponsor.website || '',
      image: null,
      imageUrl: sponsor.logo_url || sponsor.image_url || sponsor.imageUrl || '',
      removeImage: false
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image: file,
        imageUrl: URL.createObjectURL(file),
        removeImage: false
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const payload = { ...formData };
      
      if (editingId) {
        if (payload.removeImage) payload.remove_image = true;
        await updateSponsor(editingId, payload);
        toast.success('Sponsor updated successfully');
      } else {
        await addSponsor(payload);
        toast.success('Sponsor added successfully');
      }
      
      closeModal();
    } catch (error) {
      toast.error('Error saving sponsor: ' + (error.message || 'Unknown error'));
    }
  };

  const handleDelete = async (id, e) => {
    e?.stopPropagation();
    
    if (window.confirm('Are you sure you want to delete this sponsor?')) {
      try {
        await deleteSponsor(id);
        toast.success('Sponsor deleted successfully');
      } catch (error) {
        toast.error('Error deleting sponsor: ' + (error.message || 'Unknown error'));
      }
    }
  };

  if (loading) return <div className="loading-state">Loading sponsors...</div>;
  if (error) return <div className="error-state">Error: {error}</div>;

  const sponsorsList = Array.isArray(sponsors) ? sponsors : [];

  return (
    <div className="manage-sponsors">
      <div className="page-header">
        <h2>Manage Partners</h2>
        <button 
          className="btn btn-primary"
          onClick={openAddModal}
          type="button"
        >
          <RiAddLine /> Add New Partner
        </button>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingId ? 'Edit Sponsor' : 'Add New Sponsor'}</h3>
              <button className="modal-close" onClick={closeModal}>
                <RiCloseLine />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Sponsor Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter sponsor name"
                />
              </div>

              <div className="form-group">
                <label>Category *</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Website URL</label>
                <input
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleInputChange}
                  placeholder="https://example.com"
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Enter sponsor description"
                />
              </div>

              <div className="form-group">
                <label>Logo Image</label>
                <div className="image-upload">
                  {formData.imageUrl ? (
                    <img src={formData.imageUrl} alt="Preview" className="image-preview" />
                  ) : (
                    <div className="image-placeholder">
                      <RiImageLine />
                      <span>Upload Logo</span>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="image-input"
                  />
                </div>
                
                {editingId && formData.imageUrl && !formData.image && (
                  <div className="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="removeImage"
                        checked={formData.removeImage}
                        onChange={handleInputChange}
                      /> Remove existing image
                    </label>
                  </div>
                )}
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Update' : 'Add'} Sponsor
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {categories.map(category => {
        const categorySponsors = sponsorsList?.filter(s => s?.category === category.id);
        
        return (
          <div key={category.id} className="sponsor-category">
            <div className="category-header">
              <div className="category-icon" style={{ color: category.color }}>
                {category.icon}
              </div>
              <h3>{category.name} Partners ({categorySponsors?.length || 0})</h3>
            </div>

            {categorySponsors?.length > 0 ? (
              <div className="sponsors-grid">
                {categorySponsors.map(sponsor => (
                  <div key={sponsor.id} className="sponsor-card">
                    <div className="sponsor-logo">
                      <img src={getImageUrl(sponsor.image_url || sponsor.logo_url)} alt={sponsor.name} />
                    </div>
                    <div className="sponsor-info">
                      <h4>{sponsor.name}</h4>
                      {sponsor.description && <p>{sponsor.description}</p>}
                      {sponsor.website && (
                        <a 
                          href={sponsor.website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="website-link"
                        >
                          Visit Website
                        </a>
                      )}
                    </div>
                    <div className="sponsor-actions">
                      <button 
                        onClick={() => openEditModal(sponsor)} 
                        className="action-btn edit"
                        title="Edit sponsor"
                        type="button"
                      >
                        <RiEditLine />
                      </button>
                      <button 
                        onClick={(e) => handleDelete(sponsor.id, e)} 
                        className="action-btn delete"
                        title="Delete sponsor"
                        type="button"
                      >
                        <RiDeleteBack2Fill />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-sponsors">
                <p>No {category.name.toLowerCase()} sponsors yet.</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ManageSponsors;